import React from 'react';
import PropTypes from 'prop-types';

import MaterialCard from '@material-ui/core/Card';
import MaterialCardContent from '@material-ui/core/CardContent';

const Card = React.forwardRef(({ children, className }, ref) => (
  <MaterialCard ref={ref} className={className}>
    <MaterialCardContent>{children}</MaterialCardContent>
  </MaterialCard>
));

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Card;
